import { array } from 'prop-types'

import scope from 'recompose-scope/composeWithScope'
import consumeProps from 'recompose-scope/consumeProps'
import exposeProps from 'recompose-scope/exposeProps'

import compose from 'recompose/compose'
import lifecycle from 'recompose/lifecycle'
import withProps from 'recompose/withProps'

import zipObject from 'lodash/zipObject'

import RowView from './Row'

const Row = compose(
  lifecycle({
    shouldComponentUpdate (nextProps) {
      if (nextProps.gridValues[this.props.s] !== this.props.gridValues[this.props.s]) return true
      const lastFrom = this.props.using.fromCell
      const nextFrom = nextProps.using.fromCell
      if (!nextFrom && lastFrom && lastFrom.s === this.props.s) return true
      if (!lastFrom && nextFrom && nextFrom.s === nextProps.s) return true
      if (nextProps.scope !== this.props.scope) return true
      return false
    },
  }),

  scope(
    consumeProps({
      ranges: array.isRequired,
    }),

    withProps(({ ranges }) => ({
      rangeColors: zipObject(ranges.map(r => r.key), ranges.map(r => r.color)),
    })),

    exposeProps([
      'rangeColors',
    ]),
  )
)(RowView)

Row.displayName = 'Row'

export default Row



// WEBPACK FOOTER //
// ./src/components/RangeEditor/Grid/Row/index.js